import { palettePrimaryMain } from '@/theme/designTokens'

/** Figma 5062:8528 / 5062:9013 — workspace chrome & panels */
export const routingNavy = '#04183f'
export const routingSubtitle = '#6b7a90'
export const routingMutedPrompt = '#9aaab8'
export const routingPanelBorder = '#e1e7f3'
export const routingRuleCardBorder = '#e4e9f0'
export const routingRowSelectedBg = '#f0f8fd'
export const routingRowSelectedBorder = '#b0e5ff'
export const routingRowInactiveBg = 'rgba(118, 118, 128, 0.12)'
export const routingRowInactiveBorder = '#bfc7cb'
export const routingCanvasBg = '#f9fafb'
export const routingHint = '#a0abbf'

export const routingPrimary = palettePrimaryMain
export {
  borderDefault as routingBorder,
  paletteSuccessMain as routingSuccess,
  textPrimary as routingInk,
  textSecondary as routingSecondary,
} from '@/theme/designTokens'

export const ROUTING_FIELD_LABEL_SX = {
  fontWeight: 600,
  fontSize: '11px',
  lineHeight: '16.5px',
  letterSpacing: '0.275px',
  textTransform: 'uppercase',
  color: routingSubtitle,
} as const

export const ROUTING_OUTLINED_BTN_SX = {
  textTransform: 'none',
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.1px',
  height: 40,
  minHeight: 40,
  py: '10px',
  px: '16px',
  bgcolor: '#fff',
  boxShadow: 'none',
  flexShrink: 0,
} as const

/** Figma 4687:5284 / 5062:9392 — rule-row drag handle (16px grid icon) */
export const ROUTING_RULE_DRAG_HANDLE_COLOR = routingSubtitle

export const ROUTING_RULE_DRAG_HANDLE_SX = {
  p: 0,
  width: 16,
  height: 16,
  minWidth: 16,
  flexShrink: 0,
  color: ROUTING_RULE_DRAG_HANDLE_COLOR,
  cursor: 'grab',
  touchAction: 'none',
  '&:hover': { bgcolor: 'transparent', color: ROUTING_RULE_DRAG_HANDLE_COLOR },
} as const

/** Figma 5062:9374 — rule row spacing (drag→fields 12px, columns 13px, fields→delete 17px) */
export const ROUTING_RULE_ROW_DRAG_FIELDS_GAP = '12px'
export const ROUTING_RULE_FIELD_COLUMN_GAP = '13px'
export const ROUTING_RULE_FIELDS_DELETE_GAP = '17px'
/** Label 16.5px + 6px gap — aligns delete-bin (y=25) with 36px dropdown (y=22.5) per 4687:5291 */
export const ROUTING_RULE_DELETE_TOP_OFFSET = '22.5px'

/** Figma 4687:5281 — dropdown field (36×h, 10px radius, Body_Me_12) */
export const ROUTING_RULE_FIELD_CONTROL_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '10px',
    height: 36,
    minHeight: 36,
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    bgcolor: '#fff',
    '& fieldset': { borderColor: routingRuleCardBorder },
  },
  '& .MuiSelect-select': {
    py: '10px',
    pl: '10px',
    pr: '36px !important',
    minHeight: '16px !important',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiSelect-icon': {
    fontSize: 24,
    right: 7,
    top: 'calc(50% - 12px)',
  },
  '& .MuiInputBase-input': {
    py: '10px',
    px: '10px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    height: 36,
    boxSizing: 'border-box',
  },
} as const

/** Figma 4687:5291 / 5062:9399 — rule row delete (delete-bin-line 24×24, #ef4444) */
export const ROUTING_RULE_DELETE_COLOR = '#ef4444'

export const ROUTING_RULE_DELETE_BTN_SX = {
  p: 0,
  width: 24,
  height: 24,
  minWidth: 24,
  flexShrink: 0,
  mt: ROUTING_RULE_DELETE_TOP_OFFSET,
  ml: ROUTING_RULE_FIELDS_DELETE_GAP,
  color: ROUTING_RULE_DELETE_COLOR,
  borderRadius: '4px',
  '&:hover': { bgcolor: 'rgba(239, 68, 68, 0.08)' },
} as const

/** Figma 4687:4888 / 4687:5224 — primary Continue (label only, no trailing chevron) */
export const ROUTING_CONTINUE_PRIMARY_BTN_SX = {
  ...ROUTING_OUTLINED_BTN_SX,
  bgcolor: routingPrimary,
  color: '#fff',
  border: 'none',
  minWidth: 'unset',
  px: '16px',
  '& .MuiButton-endIcon': { display: 'none', margin: 0, width: 0 },
  '&:hover': { bgcolor: '#0076b0', boxShadow: 'none' },
} as const

/** @deprecated Use ROUTING_CONTINUE_PRIMARY_BTN_SX */
export const ROUTING_LOCKED_CONTINUE_BTN_SX = ROUTING_CONTINUE_PRIMARY_BTN_SX
